'use client';

import { useQuery } from '@tanstack/react-query';
import { staticQrQueryOptions } from '@/features/totems/presentation/queries/totems.queries';

/**
 * QR estático del punto de venta (Mercado Pago / Yacare).
 * `enabled` permite montar el hook sin consultar hasta que haga falta (p. ej. solo en modo `static`).
 */
export const useStaticQr = (totemId: string, { enabled = true }: { enabled?: boolean } = {}) =>
  useQuery({ ...staticQrQueryOptions(totemId), enabled: enabled && Boolean(totemId) });
